<template>
	<transition name="fade">
		<div v-if="serviceExplainedModalOpen" class="modal" tabindex="-1" ref="waModal">
			<div class="modal-dialog modal-lg">
				<div class="modal-content px-2">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ service.name }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="this.$parent.serviceExplainedModalOpen = false"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <p v-html="service.long_description"></p>
                                <p v-html="service.modal_text"></p>
                            </div>
                        </div>
                    </div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
    export default {
        props: ['service', 'serviceExplainedModalOpen'],
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {

        },
        computed: {

        }
    }
</script>
<style lang="scss" scoped>
    .error {
        color: red;
    }
    .modal {
		background-color: rgba(0,0,0,.5);
	  	display: block;
	}
</style>